import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";
import { AuthContext } from "../context/AuthContext";

export default function Login() {
  const navigate = useNavigate();
  const { setAuth } = useContext(AuthContext);

  const [form, setForm] = useState({ email: "", password: "" });
  const [err, setErr] = useState(null);

  const handle = async (e) => {
    e.preventDefault();
    setErr(null);

    try {
      const data = await api.post("/auth/login", form);

      // Extract token
      const token = data.token || data.access_token;
      if (!token) throw new Error("Login failed: No token received");

      // Extract user/fighter
      const account = data.user || data.fighter;
      if (!account) throw new Error("Invalid login credentials");

      // Determine role
      const role = account.role || (account.fighter_id ? "fighter" : "user");

      const normalizedUser = {
        id: account.fighter_id ?? account.user_id ?? null,
        fighter_id: account.fighter_id ?? null,
        user_id: account.user_id ?? null,
        name: account.name ?? "",
        surname: account.surname ?? "",
        email: account.email ?? "",
        role,
        image_url: account.image_url ?? null,
      };

      // Save to context + localStorage
      setAuth(token, normalizedUser);

      console.log("Saved token:", localStorage.getItem("userToken"));
      console.log("Saved user:", localStorage.getItem("userInfo"));

      // Redirect
      if (role === "admin") navigate("/admin/dashboard");
      else navigate("/profile");
    } catch (e) {
      setErr(e.message || "Login failed");
      console.error("Login error:", e);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-zinc-900/80 p-8 rounded-xl shadow-xl border border-zinc-700 backdrop-blur">
        <h1 className="text-3xl font-extrabold text-yellow-400 mb-6 text-center uppercase">
          Fighter Management
        </h1>

        <h2 className="text-xl font-semibold mb-4 text-white uppercase">Sign In</h2>

        {err && <p className="text-red-500 text-sm mb-4">{err}</p>}

        <form onSubmit={handle} className="space-y-4">
          <input
            className="w-full px-4 py-3 rounded bg-zinc-800 text-white border border-zinc-700 focus:ring-2 focus:ring-yellow-400 focus:outline-none placeholder-gray-400"
            placeholder="Email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />
          <input
            type="password"
            className="w-full px-4 py-3 rounded bg-zinc-800 text-white border border-zinc-700 focus:ring-2 focus:ring-yellow-400 focus:outline-none placeholder-gray-400"
            placeholder="Password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
          />

          <p
            className="text-yellow-400 text-sm cursor-pointer hover:underline text-right"
            onClick={() => navigate("/forgot-password")}
          >
            Forgot password?
          </p>

          <button className="w-full py-3 bg-yellow-500 hover:bg-yellow-600 text-black font-bold rounded mt-2 uppercase tracking-wide">
            Login
          </button>
        </form>

        <p className="text-gray-400 text-sm text-center mt-4">
          Don�t have an account?{" "}
          <span
            onClick={() => navigate("/register")}
            className="text-yellow-400 cursor-pointer hover:underline"
          >
            Register
          </span>
        </p>
      </div>
    </div>
  );
}
